module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-4-a093f4d7b99edb9deaffe36c5f5f9fcc.jpg";